import { NotificationAction } from "@config/local-notifications/notification-actions";
import { NotificationIcon } from "@config/local-notifications/notification-icon";
import { organizationManagerNotificationRepo } from "@repositories";
import { formatDate } from "@shared/backend/format-date";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { textBuilder } from "@shared/helpers/text-builder";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { type Mission } from "./entity";

export const MissionEntityConfig: HyperEntityConfig<Mission> = {
  allowApiRead: Allow.authenticated,
  allowApiCrud: [Roles.Admin, Roles.SuperAdmin, Roles.Manager],
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, false);

    filter([Roles.Admin, Roles.SuperAdmin], {
      organizationId: remult.user.organizationId,
    });

    filter(Roles.Manager, {
      $or: [
        {
          assignedManagerId: remult.user.id,
        },
        {
          teamId: {
            $in: remult.user.managingTeams,
          },
        },
      ],
    });
  },

  allowInsertPerRole(allow) {
    allow(
      Roles.OrganizationManagers,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(
      Roles.OrganizationManagers,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },

  async onInsert(entity, e) {
    if (
      remult.user?.name &&
      entity.creatorManagerId &&
      remult.user.id !== entity.creatorManagerId
    ) {
      const creatorManager = await e.relations.creatorManager.findOne();

      if (!creatorManager) return;

      await organizationManagerNotificationRepo.insert({
        toId: creatorManager.id,
        title: "משימה חדשה",
        icon: NotificationIcon.NEW,
        content: textBuilder()
          .add("המנהל")
          .space()
          .add(remult.user.name)
          .space()
          .add("שייך אליך משימה חדשה,")
          .space()
          .add("ב")
          .add(formatDate(entity.createdAt))
          .add(".")
          .newLine()
          .done(),
        actions: [
          {
            id: NotificationAction.NAVIGATE,
            btnText: "לפרטים",
            extra: {
              to: "/missions",
            },
          },
        ],
      });
    }
  },
};
